<h2 mat-dialog-title>
  <mat-icon svgIcon="start-debug-logging"></mat-icon>
  <div>Start debug logging</div>
</h2>
<mat-dialog-content>
  <p>
    Record debugging information for the next 8 hours to help us troubleshoot a
    technical issue you are experiencing. When you encounter a problem, click
    the button again to flag the issue to our team.
  </p>
  <h3-debug-log-id></h3-debug-log-id>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close color="primary">CANCEL</button>
  <button mat-button mat-dialog-close color="primary" (click)="startLogging()">
    START LOGGING
  </button>
</mat-dialog-actions>
